import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { LazyLoadEvent, MessageService, Table } from 'primeng';
import { ICustomerSites } from '../../interfaces/customer-sites';
import { ICustomerSitesFilter } from '../../interfaces/customer-sites-filter';
import { IPageResult } from '../../interfaces/page-result';
import { CustomerSitesService } from '../../services';
import { CustomerSiteEditorSource } from './customer-sites-editor.component';

@Component({
  selector: 'customer-sites',
  templateUrl: 'customer-sites.component.html',
  styleUrls: ['./customer-sites.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomerSitesComponent implements OnInit {
  public page: IPageResult<ICustomerSites> = {
    items: [],
    total: 0,
  };

  public isLoaded: boolean = false;
  public hasResult: boolean = true;
  public filterVal: ICustomerSitesFilter;
  public filter: Subject<ICustomerSitesFilter>;

  selectedSites: ICustomerSites;

  public editorVisible: boolean = false;

  protected readonly CustomerSiteEditorSource = CustomerSiteEditorSource;

  constructor(private csService: CustomerSitesService) {}

  ngOnInit() {
    this.initDefaultFilter();
    this.filter = new Subject<ICustomerSitesFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'siteName',
      sortOrder: 1,
      filters: {
        siteName: {},
        excludeDisabled: {},
      },
    };
  }

  load(filter: ICustomerSitesFilter) {
    this.csService.getPage(filter).then((result) => {
      this.selectedSites = null;
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
      this.hasResult = result.total != 0 ? true : false;
    });
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this.initDefaultFilter();
    this.filter.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0;
    this.filter.next(this.filterVal);
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;
    // map grid lazy load event to filter
    this.filter.next(this.filterVal);
  }

  Delete(sites: ICustomerSites) {
    this.csService.DeleteSites(sites.id).then((res) => {
      this.selectedSites = null;
      this.initDefaultFilter();
      this.filter.next(this.filterVal);
    });

    this.selectedSites = null;
  }

  editSite(site: ICustomerSites | null): void {
    this.selectedSites = site;
    this.editorVisible = true;
  }

  siteUpdated(site: ICustomerSites): void {
    this.selectedSites = site;
    this.filter.next(this.filterVal);
  }
}
